/** Cloud Function endpoint for the agent API catalog. */
export const AGENT_REGISTRY_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/agentRegistryApi';

export const AGENT_CATALOG_JSON_URL = `${process.env.PUBLIC_URL || ''}/docs/agents/catalog.json`;

export async function fetchAgentCatalog(): Promise<Record<string, unknown>> {
  const res = await fetch(`${AGENT_REGISTRY_ENDPOINT}?action=catalog`);
  if (!res.ok) {
    throw new Error(`Catalog fetch failed: HTTP ${res.status}`);
  }
  return res.json() as Promise<Record<string, unknown>>;
}
